import { render, staticRenderFns } from "./Identificacion.vue?vue&type=template&id=e4c77d8a&scoped=true"
import script from "./Identificacion.vue?vue&type=script&lang=js"
export * from "./Identificacion.vue?vue&type=script&lang=js"
import style0 from "./Identificacion.vue?vue&type=style&index=0&id=e4c77d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c77d8a",
  null
  
)

export default component.exports